const About = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>О нас</h1>
      <div style={{ maxWidth: '800px', marginTop: '2rem' }}>
        <p>
          Мы являемся ведущим порталом о гоночных соревнованиях в России. 
          Наша миссия - предоставлять актуальную информацию о всех значимых 
          событиях в мире автоспорта.
        </p>
        <div style={{ marginTop: '2rem' }}>
          <h2>Наши преимущества:</h2>
          <ul>
            <li>Актуальная информация о гонках</li>
            <li>Прямые трансляции соревнований</li>
            <li>Эксклюзивные интервью с гонщиками</li>
            <li>Профессиональные комментарии экспертов</li>
          </ul>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <h2>Контакты</h2>
          <p>Email: info@racing-portal.ru</p>
          <p>Телефон: +7 (999) 123-45-67</p>
        </div>
      </div>
    </div>
  );
};

export default About; 